"use client";

import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import { useId, useState } from "react";
import { useTranslations } from "next-intl";
import { Icon, Typography } from "@/shared/ui/atoms";
import RankingInfoTooltip from "@/widgets/search-ranking/ui/molecules/RankingInfoTooltip";
interface RankingMetaBarProps {
  totalReviewCount: number;
}
const RankingMetaBar = t0 => {
  const $ = _c(53);
  const {
    totalReviewCount
  } = t0;
  const t = useTranslations();
  const tooltipId = useId();
  const descriptionId = `${tooltipId}-description`;
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t || $[1] !== totalReviewCount) {
    const formattedCount = new Intl.NumberFormat().format(totalReviewCount);
    t6 = "flex h-[18px] items-center justify-between px-1";
    t5 = "flex min-w-0 flex-1 items-center";
    T0 = Typography;
    t1 = 14;
    t2 = 18;
    t3 = "min-w-0 font-medium text-gray-400";
    t4 = t("meta.reviewBased", {
      count: formattedCount
    });
    $[0] = t;
    $[1] = totalReviewCount;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t7 = <T0 size={t1} lineHeight={t2} className={t3}>{t4}</T0>;
    $[9] = T0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsTooltipOpen(true);
    t9 = () => setIsTooltipOpen(false);
    t10 = () => setIsTooltipOpen(true);
    t11 = () => setIsTooltipOpen(false);
    $[15] = t10;
    $[16] = t11;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[15];
    t11 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      "--width": 14,
      "--height": 14
    };
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t) {
    t13 = t("meta.tooltipLabel");
    $[20] = t;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setIsTooltipOpen(_temp);
    t15 = <Icon src="/icons/tooltip.png" alt="" width={14} height={14} className="shrink-0 opacity-80" />;
    $[22] = t14;
    $[23] = t15;
  } else {
    t14 = $[22];
    t15 = $[23];
  }
  let t16;
  if ($[24] !== descriptionId || $[25] !== isTooltipOpen || $[26] !== t13) {
    t16 = <button type="button" className="dynamic-size flex items-center justify-center" style={t12 as CSSProperties} aria-describedby={descriptionId} aria-expanded={isTooltipOpen} aria-label={t13} onClick={t14}>{t15}</button>;
    $[24] = descriptionId;
    $[25] = isTooltipOpen;
    $[26] = t13;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== isTooltipOpen || $[29] !== t || $[30] !== tooltipId) {
    t17 = isTooltipOpen ? <RankingInfoTooltip id={tooltipId} content={t("meta.tooltipContent")} /> : null;
    $[28] = isTooltipOpen;
    $[29] = t;
    $[30] = tooltipId;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t16 || $[33] !== t17) {
    t18 = <div className="relative ml-1 inline-flex shrink-0 items-center justify-center" onMouseEnter={t8} onMouseLeave={t9} onFocus={t10} onBlur={t11}>{t16}{t17}</div>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t18 || $[36] !== t5 || $[37] !== t7) {
    t19 = <div className={t5}>{t7}{t18}</div>;
    $[35] = t18;
    $[36] = t5;
    $[37] = t7;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t) {
    t20 = t("meta.updatedDaily");
    $[39] = t;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t20) {
    t21 = <div className="ml-2 flex shrink-0 items-center"><Typography size={14} lineHeight={18} className="text-center font-normal text-gray-300">{t20}</Typography></div>;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t) {
    t22 = t("meta.tooltipContent");
    $[43] = t;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== descriptionId || $[46] !== t22) {
    t23 = <p id={descriptionId} className="sr-only">{t22}</p>;
    $[45] = descriptionId;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t19 || $[49] !== t21 || $[50] !== t23 || $[51] !== t6) {
    t24 = <div className={t6}>{t19}{t21}{t23}</div>;
    $[48] = t19;
    $[49] = t21;
    $[50] = t23;
    $[51] = t6;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  return t24;
};
export default RankingMetaBar;
function _temp(prev) {
  return !prev;
}